import "./enlacesInformativos.css";

const PoliticasDePrivacidadYTerminosDeUso = () => {
  return (
    <div className="informacion mx-auto border-0 w-[100%] md:w-[80%] min-h-screen py-[30px] lg:px-0 px-[20px]">
     <h1>Política de Privacidad y Términos de Uso</h1>
    
    <section>
        <h2>1. Introducción</h2>
        <p>Este documento establece los términos y condiciones para el uso de nuestra plataforma de alojamientos temporarios. Al acceder o utilizar el sitio web, el usuario acepta estas condiciones.</p>
        <p>Nuestra plataforma actúa como un intermediario entre anfitriones y viajeros, facilitando la conexión entre ambas partes, pero sin intervenir en la gestión, pago o cumplimiento de reservas.</p>
    </section>
    
    <section>
        <h2>2. Privacidad y Protección de Datos</h2>
        <h3>2.1. Información que recopilamos</h3>
        <ul>
            <li>Datos de contacto (nombre, correo electrónico, teléfono).</li>
            <li>Información de pago (procesada por terceros seguros, no almacenamos datos financieros).</li>
            <li>Datos de navegación (cookies, IP, dispositivo, ubicación).</li>
        </ul>
        <h3>2.2. Uso de la información</h3>
        <ul>
            <li>Gestionar reservas y facilitar la comunicación entre usuarios.</li>
            <li>Mejorar la experiencia de la plataforma.</li>
            <li>Cumplir con normativas legales y de seguridad.</li>
        </ul>
        <h3>2.3. Protección de datos</h3>
        <p>Nos comprometemos a proteger la privacidad de nuestros usuarios. No vendemos ni compartimos datos personales con terceros, salvo cuando sea requerido por ley.</p>
    </section>
    
    <section>
        <h2>3. Responsabilidad de la Plataforma</h2>
        <h3>3.1. Naturaleza de nuestro servicio</h3>
        <p>Nuestra plataforma NO es propietaria, administradora ni gestora de los alojamientos. Solo facilitamos la conexión entre anfitriones y viajeros.</p>
        <p>Por lo tanto, no nos hacemos responsables de:</p>
        <ul>
            <li>Disponibilidad, condiciones o calidad de los alojamientos.</li>
            <li>Cancelaciones, modificaciones o incumplimientos de los anfitriones.</li>
            <li>Problemas de pago o reembolsos entre usuarios.</li>
            <li>Daños, pérdidas o inconvenientes sufridos durante la estadía.</li>
        </ul>
        <p>Los anfitriones son los únicos responsables de garantizar que la información publicada sea precisa y cumplir con las reservas realizadas.</p>
        <h3>3.2. Limitación de responsabilidad</h3>
        <p>En ningún caso la plataforma será responsable por daños directos, indirectos, incidentales o consecuentes derivados del uso del servicio.</p>
        <p>Los usuarios aceptan que la plataforma opera "tal cual" y "según disponibilidad", sin garantías explícitas o implícitas sobre su funcionamiento.</p>
    </section>
    
    <section>
        <h2>4. Condiciones de Uso para Viajeros y Anfitriones</h2>
        <h3>4.1. Obligaciones de los viajeros</h3>
        <ul>
            <li>Leer y aceptar las condiciones del anfitrión antes de reservar.</li>
            <li>Comunicarse directamente con el anfitrión para aclaraciones sobre la estadía.</li>
            <li>Respetar las normas del alojamiento durante la estancia.</li>
        </ul>
        <h3>4.2. Obligaciones de los anfitriones</h3>
        <ul>
            <li>Proporcionar información veraz sobre sus alojamientos.</li>
            <li>Cumplir con las reservas confirmadas.</li>
            <li>Gestionar cancelaciones y reembolsos según sus propias políticas.</li>
        </ul>
    </section>
    
    <section>
        <h2>5. Cancelaciones y Reembolsos</h2>
        <p>Cada anfitrión establece su propia política de cancelación y reembolso. La plataforma NO interviene en disputas ni realiza devoluciones en nombre de los anfitriones.</p>
    </section>
    
    <section>
        <h2>6. Resolución de Disputas</h2>
        <p>En caso de conflicto entre usuarios, la plataforma no actúa como mediador. Cualquier disputa debe resolverse directamente entre las partes involucradas.</p>
    </section>
    
    <section>
        <h2>7. Jurisdicción y Legislación Aplicable</h2>
        <p>Estos términos se rigen por las leyes del país donde opera la plataforma. Cualquier disputa legal se resolverá en los tribunales correspondientes a dicha jurisdicción.</p>
    </section>
    
    <section>
        <h2>8. Modificaciones a las Políticas</h2>
        <p>Nos reservamos el derecho de modificar estas políticas en cualquier momento. Se notificará a los usuarios sobre cambios relevantes mediante la plataforma.</p>
    </section>
    </div>
  );
};

export default PoliticasDePrivacidadYTerminosDeUso;